import React, { useContext, useEffect, useState } from "react";
import { toast } from "../../utils";
import { PhrasesContext } from "../../../context/phrasesContext";
import { getNotice } from "../../../services/Common";

const SharesAndBonds = ({
  disclosureData,
  setDisclosureData,
  setDismissedSharesAndBonds,
  disclosure,
  lang,
  resetDisclosureCustomFields,
  setSeperateRequests,
  closeModal, // ✅ new
  ServiceClassificationId,
}) => {
  const [enPhrase, arPhrase] = useContext(PhrasesContext);
  const [notice, setNotice] = useState([]);

  const updateNotice = (lang, ServiceClassificationId) => {
    getNotice(lang, ServiceClassificationId).then((res) => {
      setNotice(res);
    });
  };

  useEffect(() => {
    updateNotice(lang, ServiceClassificationId?.serviceClassficationId);
  }, []);

  console.log("NOtice", notice);
  return (
    <div className="p-[24px] ">
      <div
        className="w-full flex justify-end"
        onClick={() => {
          resetDisclosureCustomFields(disclosure.id);
          closeModal();
        }}
      >
        <img
          src="/assets/img/add-request/closeBorder.svg"
          alt="close"
          className="w-[32px] h-[32px] cursor-pointer"
        />
      </div>
      <div className="flex flex-col items-center justify-center gap-[24px]">
        <div className="flex flex-row items-center justify-center gap-[8px]">
          {/* <img
            src="/assets/img/add-request/Frame01.svg"
            alt="close"
            className=" cursor-pointer"
          />
          <img
            src="/assets/img/add-request/Frame02.svg"
            alt="close"
            className=" cursor-pointer"
          /> */}
          {notice?.logos?.map((notice, index) => (
            <img
              key={index}
              src={notice?.logoUrl}
              alt="close"
              className=" cursor-pointer"
            />
          ))}
        </div>
        <div className="w-full flex flex-col gap-[16px] items-center justify-between">
          {/* <p className="font-Almarai font-bold  text-[24px] text-[#010202] leading-[30px] md:leading-[20px]  text-center">
            {lang === "en"
              ? "Notices Stocks and Bonds"
              : "مخاطبة على الأسهم والسندات"}
              {notice?.content?.title}
              
          </p> */}
          <p
            className="font-Almarai text-[16px] leading-[24px] text-[#1A1A1A] text-center md:!text-justify"
            dangerouslySetInnerHTML={{
              __html: notice?.content?.title,
            }}
          ></p>
          <p
            className="font-Almarai text-[16px] leading-[24px] text-[#1A1A1A] text-center md:!text-justify"
            dangerouslySetInnerHTML={{
              __html: disclosureData[disclosure.id]?.suborderType?.toolTip,
            }}
          ></p>
        </div>
        <button
          disabled={Object.keys(disclosureData)?.length >= 9}
          className={`w-full h-[44px] rounded-[4px]  flex items-center justify-center ${
            Object.keys(disclosureData)?.length >= 9
              ? "bg-[#ccc]"
              : "bg-[#B68A35]"
          }`}
          onClick={(e) => {
            e.preventDefault();

            // 🚫 Prevent if max 9 requests already exist
            if (Object.keys(disclosureData)?.length >= 9) {
              console.log("noooooooooooooooooo");
              return;
            }
            const syntheticId = `${disclosure.id}-copy`;

            console.log("Creating separate request for:", disclosure.id);

            setSeperateRequests((prev) => ({
              ...prev,
              [disclosure.id]: true,
            }));

            // Clone the data for submission
            setDisclosureData((prev) => ({
              ...prev,
              [syntheticId]: {
                ...prev[disclosure.id],
                fileUpload: prev[disclosure.id]?.fileUpload || null, // preserve file
                subjectDocuments:prev[disclosure.id]?.SubjectDocuments || null,
                linkedTo: disclosure.id, // ✅ Link clone to original
              },
            }));

            closeModal();
          }}
        >
          {Object.keys(disclosureData)?.length >= 9 ? (
            <p
              className={`font-Almarai font-bold  text-[14px] text-[#fff] leading-[20px] ${
                Object.keys(disclosureData)?.length >= 9
                  ? "cursor-not-allowed"
                  : ""
              }`}
            >
              {lang === "en"
                ? enPhrase["lblMaximumRequestsReached"]
                : arPhrase["lblMaximumRequestsReached"]}
            </p>
          ) : (
            <p
              className={`font-Almarai font-bold  text-[14px] text-[#fff] leading-[20px] ${
                Object.keys(disclosureData)?.length >= 9
                  ? "cursor-not-allowed"
                  : ""
              }`}
            >
              {lang === "en"
                ? enPhrase["lblCreateTwoApps"]
                : arPhrase["lblCreateTwoApps"]}
            </p>
          )}
        </button>
      </div>
    </div>
  );
};

export default SharesAndBonds;
